import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import Button from "../../../../../components/ripple/Button";
import styles from "./NetworkCustom.module.scss";
import { CardItem } from "../../../../../components/card/Card";
import Input from "../../../../../components/Input";
import { updateBodyBuilder } from "../../../../../redux/actions/DeploymentActions";
import { immutableArraySlice, generateRandomID, scrollToAnchor } from "../../../../../helpers/common";
import { CardContext } from "../../../../../components/card/CardAdvanced";
import { APP_TYPES } from "../../_helpers/custom";

function NetworkCustom({bodyBuilder, networks, dispatch, messages}) {

    const [create, setCreate] = useState('');
    const [isNew, setIsNew] = useState(false);
    const [_networks, setNetworks] = useState(networks || []);

    // const networks = bodyBuilder.networks || [];
    const cardContext = useContext(CardContext);

    useEffect(() => {
        cardContext.calculateHeight();
    }, [bodyBuilder.networks?.length]);

    const renderNetworks = () => {
        return _networks.map((n, i) => {
            const foundIndex = networks?.findIndex(_n => _n.id === n.id);
            let apps = [];
            APP_TYPES.map(type => {
                bodyBuilder[type].map(a => {
                    if (a.network?.includes(n.id)) apps.push(a);
                })
            });
            return (
                <CardItem
                    className={styles.network}
                    id={`network-${n.id}`}
                    messages={messages}
                    key={i}
                >
                    <Input
                        id={`network-${n.id}-name`}
                        className={styles.input}
                        placeholder='Network name'
                        value={n.name || ''}
                        onChange={e => {
                            const newNetworks = [
                                ...networks.slice(0, foundIndex),
                                ...[{...n, ...{name: e.target.value || ''}}],
                                ...networks.slice(foundIndex + 1)
                            ];
                            dispatch(updateBodyBuilder({networks: newNetworks}));
                            setNetworks(newNetworks);
                            if (isNew) {
                                setTimeout(
                                    () => setIsNew(false),
                                    0
                                );
                                setTimeout(
                                    () => document.getElementById(`network-${n.id}-name`)?.focus(),
                                    1
                                );
                            }
                        }}
                        onBlur={e => {
                            if (!e.target.value) {
                                const newNetworks = immutableArraySlice(n, networks, 'id');
                                dispatch(updateBodyBuilder({networks: newNetworks}));
                                setNetworks(newNetworks);
                                setIsNew(false);
                            }
                        }}
                        isValid={messages?.find(m => m.target === `network-${n.id}-name`) ? false : undefined}
                        error={messages?.find(m => m.target === `network-${n.id}-name`)?.message}
                    />
                    <Button
                        className={styles.action}
                        onClick={() => {
                            const newNetworks = immutableArraySlice(n, networks, 'id');
                            dispatch(updateBodyBuilder({networks: newNetworks}));
                            setNetworks(newNetworks);
                        }}
                        icon='fas fa-times'
                        displayType='text'
                        visuals={{
                            borderRadius: '50%',
                        }}
                    />
                    {
                        !!apps?.length &&
                        <p className={styles.inUse}>In use for: {
                            apps.map((a, _i) => {
                                return (
                                    <React.Fragment key={_i}>
                                        <a
                                            href='/'
                                            onClick={e => {
                                                e.preventDefault();
                                                scrollToAnchor(
                                                    `app-${a._id}`,
                                                    e,
                                                    true,
                                                    'builder-container'
                                                )
                                            }}
                                        >
                                            {a.name}
                                        </a>
                                        {_i !== apps.length - 1 && `, `}
                                    </React.Fragment>
                                )
                            })
                        }</p>
                    }
                </CardItem>
            )
        })
    }

    return (
        <>
            {renderNetworks()}
            {
                !isNew &&
                <CardItem className={styles.form}>
                    <Input
                        id='network-new-field'
                        className={styles.input}
                        placeholder='Network name'
                        value={create}
                        onChange={e => setCreate(e.target.value.trim())}
                        onFocus={() => {
                            const id = generateRandomID();
                            const newNetworks = [...networks, ...[{name: '', id}]];
                            dispatch(updateBodyBuilder({networks: newNetworks}));
                            setNetworks(newNetworks);
                            setIsNew(true);
                            setTimeout(
                                () => document.getElementById(`network-${id}-name`)?.focus(),
                                1
                            );
                        }}
                    />
                    <Button
                        className={styles.action}
                        icon='fas fa-plus'
                        onClick={() => {
                            // dispatch(updateBodyBuilder({
                            //     networks: [...networks, ...[{
                            //         name: create,
                            //         id: generateRandomID()
                            //     }]]
                            // }));
                            // setCreate('');
                        }}
                        displayType='text'
                        disabled={networks?.some(n => n.name === create) || !create?.length}
                        visuals={{
                            colorBasicNotContained: ['var(--colorAccentSoft)'],
                            colorBasic: ['var(--colorAccentLight)'],
                            borderRadius: '50%',
                        }}
                    />
                </CardItem>
            }
        </>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
    networks: state.deployment.bodyBuilder.networks,
    messages: state.deployment.messages,
});

export default connect(mapStateToProps)(NetworkCustom)